import './SideMenu.scss';
import React, { useEffect } from 'react';

export interface SideMenuItem {
    path: string;
    label: string;
}

interface SideMenuProps {
    isOpen: boolean;
    onClose: () => void;
    items: SideMenuItem[];
    currentPath: string;
    onNavigate: (path: string) => void;
    isItemActive?: (item: SideMenuItem, currentPath: string) => boolean;
}

const SideMenu: React.FC<SideMenuProps> = ({
    isOpen,
    onClose,
    items,
    currentPath,
    onNavigate,
    isItemActive,
}) => {
    const resolveIsActive = (item: SideMenuItem) =>
        isItemActive ? isItemActive(item, currentPath) : currentPath === item.path;

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [isOpen, onClose]);

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    const handleNavClick = (path: string) => {
        onNavigate(path);
        onClose();
    };

    return (
        <>
            <div
                className={`side-menu-backdrop${isOpen ? ' side-menu-backdrop--visible' : ''}`}
                onClick={onClose}
                aria-hidden="true"
            />
            <nav
                className={`side-menu${isOpen ? ' side-menu--open' : ''}`}
                aria-label="Навигация по разделам"
                aria-hidden={!isOpen}
            >
                <div className="side-menu-header">
                    <span className="side-menu-title">Разделы</span>
                    <button
                        type="button"
                        className="side-menu-close"
                        onClick={onClose}
                        aria-label="Закрыть меню"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <ul className="side-menu-list">
                    {items.map((item) => (
                        <li key={item.path}>
                            <button
                                type="button"
                                className={`side-menu-item${resolveIsActive(item) ? ' side-menu-item--active' : ''}`}
                                onClick={() => handleNavClick(item.path)}
                                aria-current={resolveIsActive(item) ? 'page' : undefined}
                            >
                                {item.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    );
};

export default SideMenu;
